import {
  type QueryObserverResult,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query'

import type { ShiftDataflowResponse } from '@front/type/admin'
import type { CustomError } from '@front/type/api'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminShiftUrl } from './config'

export const useAdminShiftDataflowQueryKey = 'get-admin-shift-dataflow'

export const useAdminShiftDataflowQuery = (
  idShift: string,
  options?: Omit<
    UseQueryOptions<ShiftDataflowResponse, CustomError>,
    'queryKey' | 'queryFn'
  >,
): QueryObserverResult<ShiftDataflowResponse, CustomError> =>
  useQuery<ShiftDataflowResponse, CustomError>({
    queryKey: [useAdminShiftDataflowQueryKey, idShift],
    queryFn: async () =>
      axiosGet<ShiftDataflowResponse>(`${adminShiftUrl}/${idShift}/dataflow`),
    ...options,
  })
